import React from 'react';
import { Formik, Form } from 'formik'; // import PropTypes from 'prop-types';

import * as Yup from 'yup';
import { Button, Grid, SubmitButton, Dialog, ComercialTaskForm } from '../../../../'; // import { Debug } from '../../../../Molecules/Forms/Debug';

import { makeStyles } from '@material-ui/core/styles';
var comercialTaskSchema = Yup.object().shape({
  type: Yup.string().required('Campo obligatorio'),
  subject: Yup.string().required('Introduce el asunto de la tarea'),
  date: Yup.date()["default"](function () {
    return new Date();
  }),
  status: Yup.string().required('Campo obligatorio'),
  opportunity_status: Yup.string().required('Campo obligatorio'),
  details: Yup.string(),
  person_of_contact: Yup.string().required('Selecciona una persona de contacto')
});
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: 'flex',
      'flex-wrap': 'wrap'
    },
    mr30: {
      'margin-right': '30px'
    },
    flex: {
      display: 'flex',
      'justify-content': 'space-between'
    },
    w50: {
      width: '50%'
    },
    actions: {
      display: 'flex',
      padding: '30px',
      'justify-content': 'flex-end'
    }
  };
});

var DialogComercialTask = function DialogComercialTask(props) {
  // console.log('DialogComercialTask', props);
  var initialValues = props.variant === 'add' ? {
    subject: '',
    type: '',
    date: null,
    person_of_contact: '',
    status: '',
    opportunity_status: '',
    details: ''
  } : props.task;
  var classes = useStyles();
  var title = '';

  if (props.variant === 'edit') {
    title = 'Editar Tarea';
  } else if (props.variant === 'view') {
    title = 'Ver Tarea';
  } else if (props.variant === 'add') {
    title = 'Añadir Tarea';
  }

  return [/*#__PURE__*/React.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "lg",
    title: title,
    open: props.open,
    onClose: props.onClose,
    mode: props.variant,
    key: 0
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: props.data || initialValues,
    validationSchema: comercialTaskSchema,
    onSubmit: function onSubmit(values, _ref) {
      var resetForm = _ref.resetForm;

      // setTimeout(() => {
      // 	alert(JSON.stringify(values, null, 2));
      // }, 500);
      if (props.variant === 'add') {
        props.createTask(values);
      } else if (props.variant === 'edit') {
        props.editTask(values);
      }

      resetForm({
        subject: '',
        type: '',
        date: null,
        person_of_contact: '',
        status: '',
        opportunity_status: '',
        details: ''
      });
      props.onClose();
    },
    render: function render(_ref2) {
      var values = _ref2.values,
          isValid = _ref2.isValid,
          isSubmitting = _ref2.isSubmitting,
          errors = _ref2.errors,
          touched = _ref2.touched;
      return /*#__PURE__*/React.createElement(Form, {
        "data-cy": "add-commercial-task",
        className: classes.form
      }, /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.root
      }, /*#__PURE__*/React.createElement(Grid, {
        item: true,
        md: 12,
        className: classes.editor
      }, /*#__PURE__*/React.createElement(ComercialTaskForm, {
        values: values,
        mode: props.variant,
        translation: props.translation ? props.translation : null,
        peopleOfContact: props.peopleOfContact
      })), props.variant !== 'view' && /*#__PURE__*/React.createElement(Grid, {
        container: true,
        className: classes.actions
      }, /*#__PURE__*/React.createElement(Button, {
        "data-cy": "cancel",
        type: "button",
        size: "medium",
        className: classes.mr30,
        color: "secondary",
        variant: "outlined",
        onClick: props.onClose
      }, props.translation ? props.translation.buttons.cancel : 'Cancel'), /*#__PURE__*/React.createElement(Button, {
        "data-cy": "submit",
        size: "medium",
        color: "primary",
        variant: "outlined",
        disabled: !isValid || isSubmitting,
        component: SubmitButton,
        type: "submit"
      }, props.variant === 'add' ? props.translation ? props.translation.buttons.add : "Add" : props.translation ? props.translation.buttons.save : "Guardar"))));
    }
  })))];
};

export { DialogComercialTask };